export default __webpack_public_path__ + "static/media/colon.844b9f06.svg";